var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import * as React from 'react';
import { UitkLayoutGrid, UitkLayoutGridItem } from 'uitk-react-layout-grid';
import { ActivityMessageBanner } from '../../../../components/common/banners/activity-message-banner';
import { CategoryTileCard, PlaceholderCards } from '../../../../components/srp/modules/module-components';
import { mapMessageTileToBannerProps } from '../../../common/banners/activity-message-banner-helper';
import { ActivityTileCard } from './simple-result-card';
export var GridLayoutComponent = function (_a) {
  var activityTiles = _a.activityTiles,
    loading = _a.loading,
    onClick = _a.onClick,
    activityGroup = _a.activityGroup;
  if (loading) {
    return React.createElement(PlaceholderCards, null);
  }
  var getGridViewTile = function (activityTile, index) {
    switch (activityTile.__typename) {
      case 'Activity':
        return React.createElement(UitkLayoutGridItem, {
          key: "activity-tile-card-".concat(index)
        }, React.createElement(ActivityTileCard, {
          activity: activityTile,
          loading: false,
          index: index,
          onClick: function () {
            return onClick(activityTile, index);
          },
          activityGroup: activityGroup
        }));
      case 'ActivityMessageTile':
        return React.createElement(UitkLayoutGridItem, {
          colSpan: "all",
          key: "activity-message-card-".concat(index)
        }, React.createElement(ActivityMessageBanner, __assign({}, mapMessageTileToBannerProps(activityTile))));
      case 'ActivityBasicTile':
        return React.createElement(UitkLayoutGridItem, null, React.createElement(CategoryTileCard, {
          category: activityTile,
          index: index
        }));
      default:
        return null;
    }
  };
  var renderGridLayoutView = function () {
    return React.createElement(UitkLayoutGrid, {
      columns: {
        small: ['1fr', '1fr'],
        medium: 3
      },
      tag: "section",
      space: "three",
      alignContent: "space-between"
    }, activityTiles && activityTiles.map(function (activityTile, index) {
      return getGridViewTile(activityTile, index);
    }));
  };
  return renderGridLayoutView();
};